export type BaseType = {
    baseId: string;
    baseName: string;
  };
  
  export type VehicleType = {
    vehicleId?: string;
    callSign?: string;
    baseId?: string | null;
    shiftType?: string | null;
    noOfAttendantSeats?: number | null;
    noOfStretchers?: number | null;
    acuity?: number | null;
    deleted?: boolean | null;
    suitableForHealthshare?: boolean | null;
    fleetOfCustomer?: string | null;
    callSignPrefix?: string | null;
    fleetOfCustomerName?: string | null;
    acuityB?: boolean | null;
    acuityC?: boolean | null;
    acuityD?: boolean | null;
    acuityE?: boolean | null;
    acuityL?: boolean | null;
    acuityM?: boolean | null;
    acuityH?: boolean | null;
    isSMAVehicle?: boolean | null;
  };

  export const BASE_DROP_TARGET_TYPE = "BASE_DROP_TARGET_TYPE"